import React from 'react';
import { CTAButton } from './CTAButton';
import { pricing } from '../data/content';
export function FinalCTA() {
  return <section className="bg-lavender-light py-12 md:py-20 px-4" data-hide-sticky data-id="element-57" data-mp="3udp1evm5zus4">
      <div className="max-w-3xl mx-auto text-center" data-id="element-58" data-mp="c70wb5r477mg">
        <h2 className="font-serif text-[1.6rem] md:text-4xl lg:text-5xl font-bold text-forest leading-[1.12] md:leading-tight" data-id="element-59" data-mp="c4fu2fmwmpo6">
          Date diez minutos para{' '}
          <span className="italic text-terracotta-deep" data-id="element-60" data-mp="m3dqs5uhhpi9">hacer algo diferente.</span>
        </h2>
        <p className="mt-3 md:mt-4 font-sans text-[15px] md:text-lg text-forest/75" data-id="element-61" data-mp="h52hbw83ph0k">
          Elige una página. Toma un color. Empieza desde ahí.
        </p>

        <div className="mt-6 flex items-baseline justify-center gap-3" data-id="element-62" data-mp="qvx0ustyq2ib">
          <s className="font-sans text-lg text-forest/50" data-id="element-63" data-mp="qy16bf7if9kp">{pricing.regular}</s>
          <span className="font-serif text-5xl md:text-6xl font-bold text-forest leading-none" data-id="element-64" data-mp="14vprko5hoiqa">
            {pricing.launch}
          </span>
        </div>
        <p className="mt-2 font-sans text-[11px] font-bold uppercase tracking-wider text-sage-deep" data-id="element-65" data-mp="2c56hmm3ph1ru">
          2 bonus premium incluidos
        </p>

        <div className="mt-6" data-id="element-66" data-mp="2h3zqu2bym6m7">
          <CTAButton label={`QUIERO EMPEZAR MI PAUSA CREATIVA — ${pricing.launch} →`} mobileLabel={`EMPEZAR MI PAUSA — ${pricing.launch} →`} data-id="element-67" data-mp="2m342czmcwgfp" />
        </div>
        <p className="mt-2.5 font-sans text-[12px] md:text-sm text-forest/65" data-id="element-68" data-mp="2v3iq05msm7md">
          Acceso inmediato · Pago único · 100% digital
        </p>
        <p className="mt-2 font-sans text-[11px] md:text-xs text-forest/55" data-id="element-69" data-mp="301as1sh5ja4a">
          El importe puede visualizarse en tu moneda local al momento del pago.
        </p>
      </div>
    </section>;
}